'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackPageView = exports.trackAction = undefined;

var _usageTrackerPublic = require('usage-tracker-public');

var _events = require('growthhub-ui/events.yaml');

var _events2 = _interopRequireDefault(_events);

var _Raven = require('Raven');

var _Raven2 = _interopRequireDefault(_Raven);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window._hsq = window._hsq || [];
var _hsq = window._hsq;

window.ga = window.ga || function () {
  return 0;
};
var _ga = window.ga;

var tracker = (0, _usageTrackerPublic.createTracker)({
  events: _events2.default,
  properties: {
    namespace: 'growth-hub',
    email: null,
    hubId: null,
    lang: null
  },
  onError: function onError(err) {
    _Raven2.default.captureMessage('usage-tracker-js event error', {
      extra: {
        message: err.message
      }
    });
  },
  isExternalHost: false
});

var trackPageViewViaGA = function trackPageViewViaGA(pathname) {
  _ga('set', 'page', pathname);
  _ga('send', 'pageview');
};

var trackPageViewViaHS = function trackPageViewViaHS(pathname) {
  _hsq.push(['setPath', pathname]);
  _hsq.push(['trackPageView']);
};

var trackAction = exports.trackAction = function trackAction(event) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(event)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      tracker.track(key, event[key]);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

var trackPageView = exports.trackPageView = function trackPageView(pathname, event) {
  trackPageViewViaGA(pathname);
  trackPageViewViaHS(pathname);
  if (event) {
    trackAction(event);
  }
};


//////////////////
// WEBPACK FOOTER
// ./js/tracker.js
// module id = 617
// module chunks = 177